import { render, staticRenderFns } from "./officialNotice.vue?vue&type=template&id=21c64008&"
import script from "./officialNotice.vue?vue&type=script&lang=js&"
export * from "./officialNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports